import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Download} from '../../model';
import {MainReleaseDatasource} from '../../shared/misc/main-release-datasource';
import {ServiceReleaseDatasource} from '../../shared/misc/service-release-datasource';
import {DownloadStore} from '../../shared/services/download-store';
import {SmeService} from '../../shared/services/sme.service';
import { MatDivider } from '@angular/material/divider';
import { DownloadsTableComponent } from '../../components/downloads-table/downloads-table.component';
import { DacklExpansionPanelComponent, DacklEmptyStateComponent } from '@datev/ngx-dackl';
import { LoaderComponent } from '../../components/loader/loader.component';
import { PushPipe } from '@ngrx/component';


@Component({
    selector: 'dp-sme',
    templateUrl: './sme.component.html',
    imports: [
        MatDivider,
        DownloadsTableComponent,
        DacklExpansionPanelComponent,
        LoaderComponent,
        DacklEmptyStateComponent,
        PushPipe,
    ],
})
export class SmeComponent implements OnInit, OnDestroy {
  public selectedDownload$ = this.downloadStore.selectedDownload$;

  public mainReleaseArchiveDataSource = new MainReleaseDatasource();
  public mainReleaseDataSource = new MainReleaseDatasource();
  public serviceReleaseDataSource = new ServiceReleaseDatasource();

  constructor(
    private readonly downloadStore: DownloadStore,
    private readonly smeService: SmeService,
    @Inject('Window') private readonly window: Window,
  ) {}

  ngOnInit(): void {
    this.serviceReleaseDataSource.addDownloads(
      this.smeService.getServiceReleases(),
    );

    this.mainReleaseDataSource.addDownloads(
      this.smeService.getMainReleases({
        mainComponents: '',
        isArchived: false,
      }),
    );

    this.mainReleaseArchiveDataSource.addDownloads(
      this.smeService.getMainReleases({ mainComponents: '', isArchived: true }),
    );
  }

  ngOnDestroy(): void {
    this.mainReleaseArchiveDataSource.cleanUp();
    this.mainReleaseDataSource.cleanUp();
    this.serviceReleaseDataSource.cleanUp();
    this.downloadStore.resetSelectedDownload();
  }

  selectMainRelease(download: Download): void {
    this.downloadStore.setSelectedDownload(download);
  }

  selectServiceRelease(download: Download): void {
    this.downloadStore.setSelectedDownload(download);
  }

  reloadSite(): void {
    this.window.location.reload();
  }
}
